import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { img } from "@/lib/api";

export const Emblem = ({ className = "w-8 h-8", color = "currentColor", gem }) => (
  <svg viewBox="0 0 48 44" className={className} fill="none" aria-hidden="true">
    <path d="M7 9c3 13 31 13 34 0" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="8.6" cy="12.5" r="1.1" fill={color} />
    <circle cx="13.2" cy="16.3" r="1.5" fill={color} />
    <circle cx="34.8" cy="16.3" r="1.5" fill={color} />
    <circle cx="39.4" cy="12.5" r="1.1" fill={color} />
    <path d="M24 18.8v3.2" stroke={color} strokeWidth="1.8" />
    <path d="M24 22c-4.6 4.4-5.6 8.4-5.6 11.1a5.6 5.6 0 0 0 11.2 0c0-2.7-1-6.7-5.6-11.1Z" fill={gem || color} />
    <path d="M24 25.5l-2.8 7.6h5.6z" fill="#fff" opacity=".28" />
  </svg>
);

export const Wordmark = ({ light, size = "md" }) => (
  <span className={`font-display font-semibold leading-none ${size === "lg" ? "text-[30px] tracking-[0.3em]" : "text-[19px] sm:text-[22px] tracking-[0.28em]"} ${light ? "text-pearl" : "text-plum"}`}>
    RATNAHARA
  </span>
);

export const Logo = ({ light, size, testId = "brand-logo" }) => {
  const { site } = useStore();
  const custom = light ? site?.brand.logo_light_url || site?.brand.logo_url : site?.brand.logo_url;
  return (
    <Link to="/" data-testid={testId} className="inline-flex items-center gap-2.5" aria-label="RATNAHARA home">
      {custom ? (
        <img src={img(custom)} alt="RATNAHARA" className="h-9 sm:h-10 w-auto object-contain" />
      ) : (
        <>
          <Emblem className={size === "lg" ? "w-11 h-10" : "w-8 h-8 sm:w-9 sm:h-9"} color={light ? "#F8F4EF" : "#30202D"} gem="var(--rh-accent)" />
          <Wordmark light={light} size={size} />
        </>
      )}
    </Link>
  );
};
